import clsx from 'clsx';
import React from 'react';
import GreenCheckIcon from '../../assets/icons/check-green-icon.svg?react';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import { ManualSubscriptionStatusEnum, Organization } from '@EHSNavigator/backend';
import Input from '../Input';

interface ApproveOrganizationModalProps {
    otherClasses?: string;
    formHandler: any;
    onClose: () => void;
    organization?: Organization;
}

const ApproveOrganizationModal: React.FC<ApproveOrganizationModalProps> = ({
    otherClasses,
    formHandler,
    onClose,
    organization,
}) => {
    const approveOrganizationModalClasses = clsx(otherClasses);

    return (
        <div
            className={approveOrganizationModalClasses}
            data-testid="approve-organization-modal"
        >
            <div className="mb-6 flex w-full flex-col items-center gap-2.5 text-center lg:mb-9">
                <GreenCheckIcon className="[&>path]:fill-brand-papery h-12 w-12 md:h-85 md:w-85" />
                <h4 className="text-brand-papery">
                    {organization?.manualSubscription?.status === ManualSubscriptionStatusEnum.RequestExtension ? 'Approve Extension Request' : 'Approve Organization'}
                </h4>
                <p className="font-inter-variable text-lg leading-5 font-normal text-brand-papery">
                    {
                        organization?.manualSubscription?.status === ManualSubscriptionStatusEnum.RequestExtension ?
                            <>Do you want to approve this <span className="font-bold text-white capitalize">{organization?.name}</span> extension request? This action will activate their subscription.</> :
                            `Do you want to approve this organization access request? This action will activate their subscription.`
                    }
                </p>
            </div>

            <form action="#" onSubmit={formHandler?.handleSubmit}>
                <div className="mt-2.5 grid grid-cols-1">
                    <Input
                        onBlur={formHandler?.handleBlur}
                        label="Amount (Optional)"
                        errorMessage={
                            formHandler?.touched.amount && formHandler?.errors.amount
                                ? formHandler?.errors.amount
                                : ''
                        }
                        disabled={formHandler?.isSubmitting}
                        value={formHandler?.values.amount}
                        type="number"
                        placeholder="e.g. 1000"
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value === '' || /^\d+(\.\d{0,2})?$/.test(value)) {
                                formHandler?.setFieldValue('amount', value, true);
                            }
                        }}
                        name="amount"
                        otherClasses={{ container: 'w-full' }}
                        autoComplete="new-password"
                    />
                </div>

                <div className="mt-6 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
                    <Button
                        variant="secondary"
                        type="button"
                        size={useButtonSizeSmall()}
                        onClick={onClose}
                        disable={formHandler?.isSubmitting}
                        otherClasses="text-brand-papery hover:border-brand-papery hover:text-brand-papery"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        size={useButtonSizeSmall()}
                        loading={formHandler?.isSubmitting}
                        disable={formHandler?.isSubmitting}
                        otherClasses="bg-brand-papery hover:text-brand-papery hover:border-brand-papery"
                    >
                        Approve
                    </Button>
                </div>
            </form>

        </div>
    );
};

export default ApproveOrganizationModal;